import React, { FC } from "react";

import { PopUpContainer } from "../BookingLegacy/FormElements/PopUps/PopUpContainer";
import { ModalViewModel } from "../../Blocks/PopUp/ModalViewModel.csharp";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";

type AppointmentDetailsConfirmationProps = {
  Modal: any;
  isOpen: boolean;
  modalContent: ModalViewModel;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
};

export const AppointmentCancellationConfirmationModal: FC<AppointmentDetailsConfirmationProps> =
  ({ Modal, isOpen, modalContent, onClose, onSubmit, isLoading }) => {
    return (
      <PopUpContainer
        Modal={Modal}
        isOpen={isOpen}
        handleCloseButtonClick={onClose}
      >
        <h4>{modalContent.header}</h4>
        <div
          className="mb-3"
          dangerouslySetInnerHTML={{ __html: modalContent.description }}
        />
        <div className="d-flex justify-content-center">
          <button className="btn btn-light mb-1 me-2" onClick={onClose}>
            {modalContent.button.link.title}
          </button>
          <button
            className="btn btn-primary mb-1 me-2"
            disabled={isLoading}
            onClick={onSubmit}
          >
            {isLoading ? (
              <LoadingAnimation text={modalContent.secondButton.link.title} />
            ) : (
              modalContent.secondButton.link.title
            )}
          </button>
        </div>
      </PopUpContainer>
    );
  };
